import { Component } from '@angular/core';

@Component({
	selector: 'seira-title',
	templateUrl: './title.component.html',
	styleUrls: ['./title.component.scss'],
})
export class TitleComponent {}
